import React from "react";
import Nav from "../../../components/Nav";
import EventCard from "./EventCard";
import { GET_EVENT, GET_ALL_USERS_EVENTS } from "../gql/queries";
import { useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";

const SingleEventRsvp = () => {
    const { eventId: eventParam } = useParams();
    const { data: eventData } = useQuery(GET_EVENT, { variables: { eventId: eventParam } });
    const event = eventData?.event || {};

    const { data: allEventsData } = useQuery(GET_ALL_USERS_EVENTS);
    let events = allEventsData?.allUsersEvents || [];

    const isEventIdInUserEvents = () => {
        for (let i = 0; i < events.length; i++) {
            if (events[i]?._id === eventParam) {
                return true;
            }
        }
        return false;
    }

    return (
        <>
            <div className="navAndHeader">
                <Nav />
            </div>
            <div className="mainContainer">
                {events && isEventIdInUserEvents() ?
                    <>
                        <h1>Event RSVP</h1>
                        <div className="singleEventContainer">
                            <EventCard event={event} />
                        </div>
                    </> : <p className="invalid-invite-link-message">This invite link is invalid</p>}
            </div>
        </>
    )
};

export default SingleEventRsvp;